import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/builds/allard-pierson/allard-pierson-frontend/layouts/default.vue").then(m => m.default || m))
}